import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { ActionModal } from 'components';
import { useTranslation } from 'react-i18next';
import { useCompanies } from '../../useCompanies';
import { useNavigate } from 'hooks/useNavigate';

const ChangeStatusModal = ({ updateInProcess, onUpdate }) => {
  const { t } = useTranslation();
  const history = useNavigate();
  const { id } = useParams();
  const { singleItem } = useCompanies(false);

  const handleOk = () => {
    onUpdate(id, isPublished);
    // onClickDelete(id);
  };
  const handleCancel = () => {
    history('/admin/companies');
  };

  const isPublished = !!singleItem?.published;

  //TODO ADD TRANSLITION TO JSON (TEST TEXTS)
  return (
    <ActionModal
      title={
        isPublished
          ? t('Disattivare questa insegna?')
          : t('Attivare questa insegna?')
      }
      description={''}
      yesBtnText={t('Sì')}
      noBtnText={t('No')}
      onClickOk={handleOk}
      onCancel={handleCancel}
      loading={updateInProcess}
      value={id}
      type={'info'}
    />
  );
};

ChangeStatusModal.propTypes = {
  onClickDelete: PropTypes.func,
};

export default ChangeStatusModal;
